<template>
  <div id="app">
      <!-- environment banner --> 
    <div class="dev" v-if="isNotProduction">
        <p>This is a <strong>{{ currentEnvironment }}</strong> environment.</p>
        <p>Data is volatile and may not be persisted for long. Please use a production environment for actual asset tracking</p>
    </div>

    <AppHeader />
    <div id="content">
      <!-- component matched by the route renders below -->
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import Footer from "@/components/Footer";

export default {
  components: {
    AppHeader,
    Footer,
  },
  computed: {
     isNotProduction() {
      return !(this.currentEnvironment === 'production');
    },
    currentEnvironment() {
      return process.env.VUE_APP_MODE || 'development';
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

$image-path: "~@/../mdb/mdbvue/img";
@import "~@/../mdb/mdbvue/scss/mdb-pro.scss";

#app {
  font-family: "Barlow", "Avenir", Helvetica, Arial, sans-serif;
  color: $primary-text-color;
}

#content {
  padding-top: 1rem;
  padding-bottom: 2rem;
}

.dev {
    background-color: $red;
    padding: 8px 0;
    p {
      color: white;
      line-height: 1;
      margin-bottom: 0;
      text-align: center;
    }
  }

</style>
